import HexRgb from 'hex-rgb';

export class CssHelper {

  // hexColor ex: #ff9900
  static getCss(hexColor:string):string{

    // HEX -> RGB
    let color:any = (HexRgb(hexColor));

    const primaryColorNoAlpha = "rgba(" + color.red + "," + color.green + "," + color.blue + "," + 1.0 + ")";
    const primaryColor   = "rgba(" + color.red + "," + color.green + "," + color.blue + "," + 0.85 + ")";
    const secondaryColor = "rgba(" + color.red + "," + color.green + "," + color.blue + "," + 0.5 + ")";
    const thinColor = "rgba(" + color.red + "," + color.green + "," + color.blue + "," + 0.3 + ")";

    let style:string = '';

    style += '.mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick { color: ' + primaryColor + '; }';
    style += '.mat-flat-button.mat-primary, .mat-raised-button.mat-primary, .mat-fab.mat-primary, .mat-mini-fab.mat-primary { background-color: ' + primaryColor + '; }';
    style += '.mat-form-field.mat-focused .mat-form-field-ripple { background-color: ' + primaryColor + '; }';
    style += '.mat-input-element { caret-color: ' + primaryColor + '; }';
    style += '.mat-form-field.mat-focused .mat-form-field-label { color: ' + primaryColor + '; }';

    style += '.sub-contents-progress-wrapper .progress { background-color: ' + primaryColor + '; }';
    style += '.btn-wrapper .btn button:not(.link) { background-color: ' + primaryColor + '; }';
    style += '.question-wrapper .content .select ul li span.selected { background-color: ' + primaryColor + ' !important; }';
    style += '.question-wrapper .content .rating ul li.selected { background-color: ' + primaryColor + ' !important; }';
    style += '.oneroll-controls-container .chapter-open-btn { background-color: ' + primaryColor + ' !important; }';
    style += '.oneroll-controls-container .chapter-open-btn:hover { background-color: ' + primaryColorNoAlpha + ' !important; }';

    return style;
  }
}